import { PhotoStage } from './shared/photoStage.js';

// The stage owns its light: no shared rig (the beams come from the lenses
// detected on the photograph).
export const RIG = 'forbidden';

export const PROFILE = {
  id: 'headliner',
  family: 'photographic',
  danceability: 0.88,
  requiresTier: 0,
  energyLevel: 0.86,
  bpmMin: 120,
  bpmMax: 180,
  movement: 0.80,
  tonality: 0.45,
  enabled: true
};

// HEADLINER: the open-air main stage at night (scene a of assets/mainstage),
// filmed like a concert capture. The big show: vivid, varied palettes; beams,
// lasers, blinders, flames, CO2, coloured confetti; the screens alternate
// Mixdeck's generators, the cover and the title; the wide shot through the
// builds, the DJ and the low shot on the drop. EDM, big room, electro,
// energetic pop. Everything else is shared/photoStage.js.
const CONFIG = {
  id: 'headliner', scene: 'a',
  program: { lasers: true, strobe: true, blinders: true, flames: true, co2: true, confetti: 'palette', haze: 0.5, beamSpread: [0.025, 0.09], beamGain: 1.0, programs: ['fan', 'ballyhoo', 'cross', 'converge', 'sweep'], arms: 1, phones: 0.5, bounce: 1 },
  palettes: [[0xff2bd6, 0x2bffea, 0xffc21a], [0x3c6cff, 0xff4a3c, 0xfff06a], [0x7b2bff, 0x2bff8c, 0xff7a2b], [0xff3c8c, 0x3cc8ff, 0xffd23c]],
  screens: { mix: { content: 0.45, cover: 0.3, title: 0.25 }, exclude: [] },
  shots: { prefer: ['wide', 'dj', 'left', 'right', 'crowd'], build: 'wide', drop: ['dj', 'crowd'], calm: ['wide', 'crowd'] },
  intensityCap: 1, protectSky: false
};

export class HeadlinerVisualizer extends PhotoStage {
  constructor(options) { super(CONFIG, options); }
}
